<template>
  <div class="fts-list-designer-element">
    <!-- Element Wrapper -->
    <div class="list-designer-element-wrapper">
      <!-- Element Item -->
      <div class="list-designer-element-item" :class="{'selection-prefix': isQuerySelectionPrefix}">
        <i class="list-designer-element-icon" :class="getIcon(item.type)" v-if="getIcon(item.type)" />
        <div class="list-designer-element-name handle">{{item.displayName}}</div>
      </div>
      <!-- Element Columns -->
      <div class="list-designer-element-columns" v-if="item.type === 14 && item.fields && item.fields.length">
        <fts-list-designer-layouter :columns="item.fields.filter(x => !x.hide)" :wrap="false" :removeable="false" />
      </div>
      <!-- Element Control -->
      <div class="list-designer-element-control" v-if="!isListingAction">
        <div class="list-designer-element-control-container">
          <div class="list-designer-element-control-wrapper">
            <font-awesome-icon class="element-control-edit" :icon="['fas', 'edit']" fixedWidth @click="openModal" /> 
          </div>
          <div class="list-designer-element-control-wrapper" v-if="item.wrap">
            <div class="element-control-badge">TW</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Element Remove -->
    <div class="list-designer-element-remove" v-if="!isListingAction">
      <font-awesome-icon :icon="['fas', 'times']" fixedWidth @click="remove(item)" /> 
    </div>
    <!-- Modal -->
    <fts-modal 
      class="designer-modal list-designer-element-modal"
      headerClass="designer-header"
      contentClass="designer-body"
      footerClass="designer-footer"
      @close="closeModal"
      v-if="informationModal">
      <!-- header -->
      <template #header>
        <div class="designer-header-wrapper">  
          <div class="element-modal-header">
            <i 
              class="element-modal-info-icon" 
              :class="[getIcon(item.type), {'system': isQuerySelectionPrefix}]"
            ></i>
            <div class="designer-header-title">{{item.displayName}}</div>
          </div>
          <div class="designer-header-desc">Column Designer</div>
        </div>
        <div class="designer-header-actions">
          <fts-btn text icon class="designer-header-action" @click="closeModal">
            <font-awesome-icon :icon="['fas', 'times']"/>
          </fts-btn>
        </div>
      </template>
      <!-- body -->
      <template #body>
        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'label',
            type: 0
          }"
          comfort-design
          v-if="(isInternal && item.system) || !item.system"
        >
          <template #formLabel="{ label }">
            {{label}} <fts-release-badge alpha class="fts-align-top" v-if="item.system" />
          </template>
        </fts-form-element>

        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'width',
            type: 3
          }"
          comfort-design
        />

        <fts-form-element
          :form-data="formData"
          :item="{
            fieldName: 'wrap',
            type: 1
          }"
          comfort-design
        />

        <draggable class="element-modal-columns"
          v-if="formData.type === 14 && formData.fields && formData.fields.length" 
          v-model="formData.fields" 
          v-bind="dragOptions"
          handle=".element-modal-column-handle"
          draggable=".element-modal-column-wrapper"
        >      
          <div class="element-modal-column-wrapper" 
            v-for="column in formData.fields" 
            :key="column.id" 
            :class="{ 'column-selected': !column.hide }" 
            @click="column.hide ? showColumn(column) : hideColumn(column)"
          >
            <font-awesome-icon class="element-modal-column-handle" :icon="['fas', 'grip-vertical']" fixed-width @click.stop/>  
            <div class="element-modal-column-item">
              <i class="element-modal-column-icon" :class="getIcon(column.type)"></i>
              <div class="element-modal-column-name">{{column.displayName}}</div>
              <div class="element-modal-column-indicator">
                <font-awesome-icon :icon="['fas', 'circle']" fixed-width v-if="column.hide" />
                <font-awesome-icon :icon="['fas', 'check-circle']" fixed-width v-else />
              </div>
            </div>
          </div>
          <div slot="header" class="element-modal-label">Columns</div>
        </draggable>   
      </template>
      <!-- footer -->
      <template #footer>
        <fts-btn text @click="closeModal">
          Cancel
        </fts-btn>
        <fts-btn color="primary" box-shadow-none @click="doneModal">
          Ok
        </fts-btn>
      </template>
    </fts-modal>
  </div>
</template>

<script>
import commons from '../commons/commons';
import queryLogic from '../commons/queryLogic';
import draggable from 'vuedraggable';
import { authorizationStore } from '../store/authorizationStore';

import FTSBtn from '../elements/FTSBtn';
import FTSFormElement from '../elements/FTSFormElement';
import FTSModal from '../elements/FTSModal';
import FTSReleaseBadge from '../elements/FTSReleaseBadge';

export default {
  props: {
    item: {
      type: Object
    },
    removeable: {
      type: Boolean,
      default: true
    }
  },
  components: {
    draggable,
    "fts-btn": FTSBtn,
    "fts-form-element": FTSFormElement,
    "fts-modal": FTSModal,
    "fts-release-badge": FTSReleaseBadge
  },
  data: () => ({
    dragOptions: commons.dragOptions,
    informationModal: false,
    formData: null
  }),
  methods: {
    getIcon(typeId) {
      if (typeId === "state" || typeId === "collaboration") 
        typeId = 7;

      return commons.informationIcon(typeId);
    },
    remove(item) {
      if(this.removeable)
        this.$emit('remove', item);
      else
        this.hideColumn(item);
    },
    showColumn(item) {
      this.$delete(item, 'hide');
    },
    hideColumn(item) {
      this.$set(item, 'hide', true);
    },
    openModal() {
      this.formData = _.cloneDeep(this.item);
      this.informationModal = true;
    },
    doneModal() {
      this.$emit('update', this.formData)
      this.informationModal = false;
    },
    closeModal() {
      this.informationModal = false;
    }
  },
  computed: {
    isInternal() {
      return authorizationStore.getters.isInternal;
    },
    isQuerySelectionPrefix() {
      return queryLogic.querySelectionPrefix.some(x => x.id === this.item.id);
    },
    isListingAction() {
      return this.item.id == "action" && this.item.system;
    }
  },
  beforeCreate: function () {
		this.$options.components.FtsListDesignerLayouter = require('./FTSListDesignerLayouter').default;
	}
}
</script>

<style lang="scss">
.fts-list-designer-element {
  display: flex;
  border: 1px solid #f5f5f5;
  background-color: var(--fts-card-background);
  .list-designer-element-wrapper {
    padding: .575rem .75rem;
    .list-designer-element-item {
      display: flex;
      align-items: center;
      font-size: 0.875rem;
      line-height: 1.5;
      .list-designer-element-icon {
        margin-right: 0.375rem;
      }
      .list-designer-element-name {
        &:hover {
          cursor: grab;
        }
      }
      .list-designer-element-badge {
        margin-left: .375rem;
      }
    }

    .list-designer-element-columns {
      margin-top: .275rem;
    }

    .list-designer-element-control {
      display: flex;
      margin-top: .275rem;
      .list-designer-element-control-container {
        display: flex;
        align-items: center;
        margin: -.275rem;
        .list-designer-element-control-wrapper {
          margin: .275rem;
          &.element-control-active {
            svg {
              color: var(--fts-primary);
            }
          }
          .element-control-edit {
            &:hover {
              color: var(--fts-primary);
            }
          }
          .element-control-badge {
            padding: 2px 6px;
            border-radius: 0.25rem;
            font-size: .575rem;
            font-weight: 500;
            background-color: var(--fts-gray-100);
          }
          svg {
            font-size: .875rem;
            color: var(--fts-default);
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .list-designer-element-remove {
    svg {
      margin: .675rem .475rem 0;
      font-size: .75rem;
      color: var(--fts-default);
      &:hover {
        color: var(--fts-danger);
        cursor: pointer;
      }
    }
  }

  .list-designer-element-modal {
    .element-modal-header {
      min-width: 0;
      display: flex;
      align-items: center;
      .element-modal-info-icon {
        margin-right: .575rem;
        font-size: 1.25rem;
      }
    }
    .element-modal-columns {
      margin: .375rem;
      .element-modal-label {
        font-weight: 500;
        font-size: 0.75rem;
      }
      .element-modal-column-wrapper {
        display: flex;
        align-items: center;
        margin-top: 0.75rem;
        padding: 0.5rem 0.75rem;
        border-radius: 0.25rem;
        cursor: pointer;
        &.column-selected {
          box-shadow: var(--fts-elevation-1);
          background-color: var(--fts-card-background);
          .element-modal-column-item {
            .element-modal-column-indicator {
              color: var(--fts-success);
            }
          }
        }
        &:not(.column-selected) {
          background-color: var(--fts-gray-100);
          color: var(--fts-default);
          .element-modal-column-item {
            .element-modal-column-icon {
              filter: grayscale(1);
            }
          }
        }
        .element-modal-column-handle {
          margin-right: .375rem;
          font-size: .75rem;
          color: var(--fts-default);
          cursor: grab;
        }
        .element-modal-column-item {
          position: relative;
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-left: 1.5rem;
          .element-modal-column-icon {
            position: absolute;
            top: 1px;
            left: 0;
          }
          .element-modal-column-name {
            font-size: 0.875rem;
            line-height: 1.25rem;
          }
          .element-modal-column-indicator {
            color: var(--fts-gray-100);
          }
        }
      }
    }
  }
}
</style>